// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__lRi9Z","navigation":"layout_navigation__xWr0o","content":"layout_content__FMuW5"};